import { ShapeUtils, Shape, Path } from 'three';
import type { PolygonWithHoles, Triangulation } from './types';

export function triangulate(poly: PolygonWithHoles): Triangulation {
  const shape = new Shape();

  const outer = poly.outer;
  if (outer.length > 0) {
    shape.moveTo(outer[0]![0], outer[0]![1]);
    for (let i = 1; i < outer.length; i++) {
      shape.lineTo(outer[i]![0], outer[i]![1]);
    }
    shape.closePath();
  }

  for (const hole of poly.holes) {
    if (hole.length > 0) {
      const holePath = new Path();
      holePath.moveTo(hole[0]![0], hole[0]![1]);
      for (let i = 1; i < hole.length; i++) {
        holePath.lineTo(hole[i]![0], hole[i]![1]);
      }
      holePath.closePath();
      shape.holes.push(holePath);
    }
  }

  const shapePoints = shape.getPoints();
  const holeArrays = shape.holes.map((h) => h.getPoints());
  const triangleIndices = ShapeUtils.triangulateShape(shapePoints, holeArrays);

  const allPoints = [...shapePoints];
  for (const holePoints of holeArrays) {
    allPoints.push(...holePoints);
  }

  const positions = new Float64Array(allPoints.length * 2);
  for (let i = 0; i < allPoints.length; i++) {
    positions[i * 2] = allPoints[i]!.x;
    positions[i * 2 + 1] = allPoints[i]!.y;
  }

  const indices = new Uint32Array(triangleIndices.length * 3);
  for (let i = 0; i < triangleIndices.length; i++) {
    const tri = triangleIndices[i]!;
    indices[i * 3] = tri[0] ?? 0;
    indices[i * 3 + 1] = tri[1] ?? 0;
    indices[i * 3 + 2] = tri[2] ?? 0;
  }

  return { positions, indices };
}
